import React from 'react';
import { SectionHeading } from './SectionHeading';
const items = [{
  emoji: '📦',
  label: 'Karton'
}, {
  emoji: '🧴',
  label: 'Flaschen'
}, {
  emoji: '✂️',
  label: 'Schere'
}, {
  emoji: '🖊️',
  label: 'Stifte'
}, {
  emoji: '🔧',
  label: 'Klebeband'
}, {
  emoji: '🪩',
  label: 'Flaschendeckel'
}];
export function Materials() {
  return <section className="w-full bg-cream py-16 sm:py-24" data-id="element-105">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-106">
        <SectionHeading eyebrow="🛒 Was du brauchst" title={<>Nur Alltagsgegenstände von zu Hause</>} subtitle="Keine Robotik-Sets. Keine teuren Teile. Nur Dinge, die du bereits hast." data-id="element-107" />
        <div className="mt-12 grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-6" data-id="element-108">
          {items.map(it => <div key={it.label} className="flex flex-col items-center gap-3 rounded-2xl border border-ink/10 bg-white px-4 py-8 text-center" data-id="element-109">
              <span className="text-4xl" aria-hidden="true" data-id="element-110">
                {it.emoji}
              </span>
              <span className="text-sm font-semibold text-ink" data-id="element-111">{it.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}